"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const Title_1 = __importDefault(require("./Title"));
const styles_1 = require("./styles");
const user_json_1 = __importDefault(require("../../../dist/user.json"));
const Header = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(styles_1.HeaderWrapper, { children: [(0, jsx_runtime_1.jsx)(Title_1.default, { title: user_json_1.default.name, subtitle: t(user_json_1.default.career) }), (0, jsx_runtime_1.jsx)(styles_1.RoundImg, { width: "128", height: "128", src: user_json_1.default.avatarUrl })] }));
};
exports.default = Header;
